import _ from 'lodash';
import React, {FunctionComponent, ReactNode, useState} from 'react';
import {Grid} from '@material-ui/core';
import {ProductData, ProductInCatalog} from '@treez/commons/sharedTypings/product';
import MergeProductColumn from './mergeProductGrid/mergeProductColumn/MergeProductColumn';

interface Props {
    fieldsToShow: ProductData[];
    mergeToThisProduct: (productSelected: ProductInCatalog) => void;
    products?: ProductInCatalog[];
    placeholder?: ReactNode;
    removeProduct: (productId: number) => void;
}

export const ProductColumnCarousel: FunctionComponent<Props> = (props: Props) => {
    const {
        fieldsToShow,
        mergeToThisProduct,
        products = [],
        placeholder = <Grid />,
        removeProduct,
    } = props;

    const [currentIndex] = useState<number>(0);

    const noProductsPresent = _.size(products) === 0;

    return (
        <Grid>
            {noProductsPresent && placeholder}
            {!noProductsPresent && (
                <MergeProductColumn
                    fieldsToShow={fieldsToShow}
                    mergeToThisProduct={mergeToThisProduct}
                    product={products[currentIndex]}
                    removeProduct={removeProduct}
                />
            )}
        </Grid>
    );
};

export default ProductColumnCarousel;
